<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        User
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">User</a>
        </li>
      </ul>
    </div>
    <div>
      <b-row>
        <b-col lg="12" xl="12">
          <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" >
            <b-tab title="Information">
              <b-card>
                <div class="d-flex flex-wrap align-items-center">
                  <div class="title mr-auto">
                    User Info
                  </div>
                  <div class="col-xl-1 col-md-12  d-flex align-self-center">
                    <span class="pull-right" v-if="!add && model.created_at">Created_at ({{model.created_at | sdate}} @ {{model.last_addr || '-'}})</span>
                  </div>
                </div>
                <hr>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="Allow_login" label-for="ph_use">
                      Allow login
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox disabled" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                      <div class="checkbox-animate disabled">
                        <span class="checkbox-off">OFF</span>
                        <span class="checkbox-on">ON</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="Email_verified" label-for="ph_active">
                      Email verified
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox disabled" name="Email_verified" id="Email_verified" v-model="model.is_verified" :disabled="lock">
                      <div class="checkbox-animate disabled">
                        <span class="checkbox-off">OFF</span>
                        <span class="checkbox-on">ON</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <label class="col-form-label">
                      Last_visit
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.id">
                    <b-form-input type="text" :value="model.last_visit | datetime" plaintext></b-form-input>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center" v-else>
                    -
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_group">
                      Permission
                      <span class="text-danger ml-1">*</span>
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <select class="form-control" v-if="!lock" label="name" v-model="model.permissions">
                      <option v-for="(item, index) in codes.permissions_user" :key="index" :value="item">{{item}}</option>
                    </select>
                    <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="The username recommended E-mail address.">Username(ID)<span class="text-danger ml-1">*</span></label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input @change="auto_set_nickname($event, model.username)" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <label class="col-form-label" for="ph_nickname">Nickname<span class="text-danger ml-1">*</span></label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
                  </div>
                </div>
                <div class="row mb-2" v-show="add || !lock">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <b-form-group>
                      <label class="col-form-label" for="ph_pass">{{add ? '' : 'Change'}} Password<span class="text-danger ml-1">*</span></label>
                    </b-form-group>
                  </div>
                  <div class="col-xl-4 col-md-12">
                    <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
                    <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                      Min Length : 10
                    </b-badge>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
                    <b-form-group>
                      <label class="col-form-label" for="ph_pass2">Password Repeat<span class="text-danger ml-1">*</span></label>
                    </b-form-group>
                  </div>
                  <div class="col-xl-4 col-md-12" v-if="model.new_password">
                    <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat"  :plaintext="lock"></b-form-input>
                  </div>
                </div>
                <b-badge class="mt-3" variant="warning"> Info </b-badge>
                : If you set your password to blank, send a link to reset your password for 48 hours.
                <div class="row mb-4 mt-3">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <b-form-group>
                      <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">List of allowed IPs</label>
                    </b-form-group>
                  </div>
                  <div class="col-xl-10 col-md-12">
                    <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :disabled="lock"></b-form-textarea>
                  </div>
                </div>
                <b-button v-if="!lock" size="sm" class="btn btn-add" @click="save"> Save </b-button>
                <b-button v-else size="sm" variant="warning" @click="lock = false" :disabled="model.is_del">
                  {{ model.is_del ? 'User was deleted' : 'Edit'}}
                </b-button>
                <b-button v-if="!lock" size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
                <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id && !model.is_del && lock" :disabled="model.is_del"> Remove </b-button>
                <b-button size="sm" class="btn btn-cancel" @click="send_password_reset_mail" v-if="model.id && !model.is_del" :disabled="model.is_del"> Send Password Reset Mail </b-button>
                <b-button size="sm" class="btn btn-addition" @click="send_ip_reset_mail" v-if="model.id && !model.is_del" :disabled="model.is_del"> Send IP ACL Reset Mail </b-button>
                <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
                </b-card>
                <b-card>
                <!-- start group info -->
                <div class="d-flex flex-wrap align-items-center">
                  <div class="title mr-auto">
                    Group Information<span class="text-danger ml-1">*</span>
                  </div>
                </div>
                <hr>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <label  class="col-form-label" for="ph_name">Group Name</label>
                  </div>
                  <div v-if="!model.group.groupname" class="col-xl-2 col-md-12">
                    <b-button id="ph_search_group" :variant="model.group.groupname ? 'primary' : 'add'" @click="chainGroup = true">Group Select</b-button>
                  </div>
                  <div v-else class="col-xl-4 col-md-12">
                    <b-form-group>
                      <b-form-input type="text" v-if="lock" v-model="model.group.groupname" plaintext></b-form-input>
                      <b-form-input v-else @keydown.enter="refresh" type="text" v-model="model.group.groupname" :disabled="true"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.group.id">
                    <label class="col-form-label" label="Verified" label-for="ph_use"
                      v-b-tooltip.hover title="Verified Allow login.">
                      Allow login
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.group.id">
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox disabled" name="Email_verified" id="Email_verified" v-model="model.group.is_verified" :disabled="true">
                      <div class="checkbox-animate disabled">
                        <span class="checkbox-off">OFF</span>
                        <span class="checkbox-on">ON</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2"  v-if="model.group.id">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_service" v-b-tooltip.hover title="Service">Service</label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <v-select v-if="add" :disabled="true" label="name" v-model="model.group.service" :options="codes.service_name"></v-select>
                    <h4 v-else>
                      <b-badge  :variant="model.group.service == 'Basic' ? 'info' : 'success'"> {{model.group.service}} </b-badge>
                    </h4>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" label="Member's" label-for="ph_count">
                      Member's
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    {{model.group.count || 0}}
                  </div>
                </div>
                <div class="row mb-2"  v-if="model.group.id">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_email">
                      E-mail
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input type="text" v-if="lock" v-model="model.group.email" plaintext></b-form-input>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" label="contact" label-for="ph_contact">
                      contact
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input type="text" id="ph_contact" v-if="lock" v-model="model.group.contact" plaintext></b-form-input>
                  </div>
                </div>
                <div class="row mb-2" v-if="model.group.id">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_address">
                      Address
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input md=12 type="text" v-if="lock" id="ph_address" v-model="model.group.address" plaintext></b-form-input>
                  </div>
                </div>
                <div class="d-flex flex-wrap align-items-center mt-5">
                  <div class="title mr-auto"  v-if="model.group.id">
                    Region
                  </div>
                </div>
                <hr>
                <b-row v-if="model.group.id">
                  <b-col md="4">
                    <b-form-group class="col-form-label" label="country" label-for="ph_country">
                      <select class="form-control" label="name" v-model="region.country" :disabled="true">
                        <option v-for="(item, index) in codes.country" :key="index" :value="item">{{item.name}}</option>
                      </select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group class="col-form-label" label="language" label-for="ph_language">
                      <select class="form-control" label="name" v-model="region.language" :disabled="true">
                        <option v-for="(item, index) in codes.language" :key="index" :value="item">{{item.name}}</option>
                      </select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group class="col-form-label" label="timezone" label-for="ph_timezone">
                      <select class="form-control" label="name" v-model="region.timezone" :disabled="true">
                        <option v-for="(item, index) in codes.timezone" :key="index" :value="item">{{ item.name }}</option>
                      </select>
                    </b-form-group>
                  </b-col>
                </b-row>
                  <!-- end group info -->
              <div>
                <div class="d-flex flex-wrap">
                  <div class="mr-auto">
                  </div>
                  <div class="mr-2">
                    <b-button v-if="!add" size="sm" class="pull-right mx-1" variant="primary" @click="groupList"> Group Detail </b-button>
                  </div>
                </div>
              </div>
            </b-card>
          </b-tab>
          <b-tab title="Login Log" border-variant="primary" :disabled="!model.id">
            <!-- 해당 사용자의 로그인 목록 -->
            <log-Login-List v-if="model.id" :user="model"></log-Login-List>
          </b-tab>
          <b-tab title="Action Log" border-variant="primary" :disabled="!model.id">
            <!-- 해당 사용자의 액션 목록 -->
            <log-Action-List v-if="model.id" :user="model"></log-Action-List>
          </b-tab>
          <b-modal title="Deletion of information" class="modal-danger" header-bg-variant="danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark">
            Are you sure you want to delete this user?
          </b-modal>
          <!-- start connect group modal -->
          <b-modal title="Find then Group and Select" size="lg" v-model="chainGroup" @ok="chainGroup = false" ok-variant="primary" ok-only>
            <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
          </b-modal>
          <!-- end connect group modal -->
          </b-tabs>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>